import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const LandingPage = ({ prompt, data }) => {
  const { FiExternalLink } = FiIcons;

  const openPlatformSite = (platform) => {
    const urls = {
      ghl: 'https://www.gohighlevel.com/?fp_ref=nikobe-sky-media85',
      lumadious: 'https://app.lumadious.us',
      wordpress: 'https://wordpress.com',
      webflow: 'https://webflow.com',
      shopify: 'https://www.shopify.com'
    };
    window.open(urls[platform], '_blank');
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Create Your Inclusive Travel Platform
        </h1>
        <p className="text-xl text-gray-300 max-w-3xl mx-auto">
          Build a powerful online presence with our integrated platform solutions
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* GoHighLevel Card */}
        <div className="bg-gray-800 rounded-xl p-6 hover:bg-gray-700 transition-all">
          <h3 className="text-2xl font-bold text-yellow-400 mb-4">GoHighLevel CRM</h3>
          <p className="text-gray-300 mb-6">
            All-in-one marketing platform for travel businesses
          </p>
          <button
            onClick={() => openPlatformSite('ghl')}
            className="bg-yellow-500 hover:bg-yellow-400 text-black px-6 py-3 rounded-lg flex items-center space-x-2 w-full justify-center"
          >
            <SafeIcon icon={FiExternalLink} />
            <span>Access GHL Platform</span>
          </button>
        </div>

        {/* Clarity with Jahx Card */}
        <div className="bg-gray-800 rounded-xl p-6 hover:bg-gray-700 transition-all">
          <h3 className="text-2xl font-bold text-blue-400 mb-4">Clarity with Jahx Dashboard</h3>
          <p className="text-gray-300 mb-6">
            Manage your inclusive travel content and campaigns
          </p>
          <button
            onClick={() => openPlatformSite('lumadious')}
            className="bg-blue-500 hover:bg-blue-400 text-white px-6 py-3 rounded-lg flex items-center space-x-2 w-full justify-center"
          >
            <SafeIcon icon={FiExternalLink} />
            <span>Open Clarity with Jahx</span>
          </button>
        </div>

        {/* Additional Platform Options */}
        <div className="bg-gray-800 rounded-xl p-6">
          <h3 className="text-2xl font-bold text-purple-400 mb-4">Additional Platforms</h3>
          <div className="space-y-4">
            <button
              onClick={() => openPlatformSite('wordpress')}
              className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 w-full"
            >
              <SafeIcon icon={FiExternalLink} />
              <span>WordPress</span>
            </button>
            <button
              onClick={() => openPlatformSite('webflow')}
              className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 w-full"
            >
              <SafeIcon icon={FiExternalLink} />
              <span>Webflow</span>
            </button>
            <button
              onClick={() => openPlatformSite('shopify')}
              className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 w-full"
            >
              <SafeIcon icon={FiExternalLink} />
              <span>Shopify</span>
            </button>
          </div>
        </div>
      </div>

      <div className="mt-12 bg-gray-800 rounded-xl p-8">
        <h2 className="text-2xl font-bold text-white mb-6">Platform Integration Benefits</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-gray-700 rounded-lg p-4">
            <h4 className="font-bold text-yellow-400 mb-2">Centralized Management</h4>
            <p className="text-gray-300">Manage all your travel content and campaigns from one dashboard</p>
          </div>
          <div className="bg-gray-700 rounded-lg p-4">
            <h4 className="font-bold text-blue-400 mb-2">Automated Workflows</h4>
            <p className="text-gray-300">Streamline your marketing and booking processes</p>
          </div>
          <div className="bg-gray-700 rounded-lg p-4">
            <h4 className="font-bold text-purple-400 mb-2">Enhanced Analytics</h4>
            <p className="text-gray-300">Track performance and optimize your travel business</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;